$(document).ready(function () {
  // ----------------------------
  // ✅ 1. Collection Highlight (jQuery)
  // ----------------------------
  const bodyClass = $("body").attr("class") || "";
  bodyClass.split(/\s+/).forEach(function (className) {
    if (className.startsWith("collection-")) {
      const collectionWords = className.replace("collection-", "").split("-").map(word => word.toLowerCase());

      $("h2").each(function () {
        const headingText = $(this).text().trim().toLowerCase();
        const matchFound = collectionWords.some(word => headingText.includes(word));

        if (matchFound) {
          $(this).addClass("active");
        }
      });
    }
  });

  // ----------------------------
  // ✅ 2. Product Page Cleanup
  // ----------------------------
  if ($("body").hasClass("template-product")) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        $(mutation.addedNodes).each(function () {
          if ($(this).is(".bcpo-title") || $(this).find(".bcpo-title").length) {
            $(this).find(".bcpo-title").each(function () {
              $(this).text($(this).text().trim().replace(":", ""));
            });
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ----------------------------
  // ✅ 3. Slider Functionality (Reusable)
  // ----------------------------
  function initSlider(section) {
    let currentIndex = 0;
    const sliderWrapper = section.find(".slider-wrapper");
    const slides = section.find(".slide");
    const totalSlides = slides.length;
    const slideWidth = section.find(".slider-container").width();
    const prevButton = section.find(".prev-slide");
    const nextButton = section.find(".next-slide");
    const controls = section.find(".slider-controls");

    if (totalSlides === 1) {
      slides.addClass("active");
      controls.hide();
      return;
    }

    sliderWrapper.css({
      width: slideWidth * totalSlides + "px",
      display: "flex",
      transition: "transform 0.5s ease-in-out"
    });

    slides.css({
      width: slideWidth + "px",
      flexShrink: "0"
    });

    function updateControls() {
      prevButton.toggleClass("disabled", currentIndex === 0);
      nextButton.toggleClass("disabled", currentIndex === totalSlides - 1);
    }

    function showSlide(index) {
      slides.removeClass("active");
      slides.eq(index).addClass("active");
      sliderWrapper.css("transform", `translateX(-${index * slideWidth}px)`);
      updateControls();
    }

    nextButton.click(function () {
      if (currentIndex < totalSlides - 1) {
        currentIndex++;
        showSlide(currentIndex);
      }
    });

    prevButton.click(function () {
      if (currentIndex > 0) {
        currentIndex--;
        showSlide(currentIndex);
      }
    });

    showSlide(currentIndex);

    $(window).resize(function () {
      const newSlideWidth = section.find(".slider-container").width();
      sliderWrapper.css("width", newSlideWidth * totalSlides + "px");
      slides.css("width", newSlideWidth + "px");
      showSlide(currentIndex);
    });
  }

  $(".grower-section, .origin-section, .kyc-section").each(function () {
    initSlider($(this));
  });
  
  // ----------------------------
  // ✅ 5. Collection Grid Background Color on Hover
  // ----------------------------
  $('.grid__item').each(function () {
    const bgColor = $(this).data('bg-color');
    const cardMedia = $(this).find('.card__media');

    if (bgColor) {
      $(this).hover(
        function () {
          cardMedia.css('background-color', bgColor);
        },
        function () {
          cardMedia.css('background-color', '');
        }
      );
    }
  });

  // ----------------------------
  // ✅ 6. Audio Clip Play/Pause
  // ----------------------------
  $(".audio-icon").click(function () {
    let audio = $(this).data("audio-el");
    let audioUrl = $(this).attr("data-audio");

    if (!audioUrl) return;

    if (!audioUrl.startsWith("http")) {
      audioUrl = "https:" + audioUrl;
    }

    if (!audio) {
      audio = new Audio(audioUrl);
      $(this).data("audio-el", audio);
    }

    if (audio.paused) {
      audio.play();
      $(this).html('Pause<i class="fas fa-pause"></i>');
    } else {
      audio.pause();
      $(this).html('Play Sound<i class="fas fa-play"></i>');
    }
  });

  // ----------------------------
  // ✅ 7. Add Class to Last Non-Empty Paragraph in RTE
  // ----------------------------
  $('.rte').each(function () {
    const $paragraphs = $(this).find('p').filter(function () {
      return $(this).text().trim().length > 0;
    });
    $paragraphs.last().addClass('last-non-empty');
  });

  // ----------------------------
  // ✅ 8. Generic Staggered Fade-Up Animation on Scroll
  // ----------------------------
  function initStaggeredAnimation(groupClass = '.animate-group', itemClass = '.animate-item') {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const $el = $(entry.target);
          const $parent = $el.closest(groupClass);
          const $siblings = $parent.find(itemClass);
          const index = $siblings.index($el);
          const delay = parseInt($parent.data('delay')) || 200;

          setTimeout(() => {
            $el.addClass('fade-up');
          }, index * delay);

          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    $(itemClass).each(function () {
      observer.observe(this);
    });
  }

  // Initialize scroll-based animation
  initStaggeredAnimation();
});

    // ----------------------------
  // ✅ 4. Origin Slider Alt text Caption
  // ----------------------------
$(window).on('load', function () {
  $('.slide').each(function () {
    var $img = $(this).find('img');
    var altText = $img.attr('alt');
    if (altText && altText.trim() !== '') {
      $(this).attr('data-caption', altText);
    }
  });
});
    // ----------------------------
  // ✅ 5. Complementary product new tab
  // ----------------------------

$(document).on('click', '.complementary-products li', function () {
  const link = $(this).find('a.full-unstyled-link').attr('href');
  if (link) {
    window.open(link, '_blank');
  }
});

$(document).on('click', '.complementary-products a.full-unstyled-link', function (e) {
  e.preventDefault(); // stop default anchor behavior
});
